<template>
  <div style="width:100%;float:left;" :class="{ 'embedded-charge-table': embedded }">
    <component :is="embedded ? 'div' : 'CCard'">
      <CCardHeader v-if="!embedded" color="secondary" @click="collapsed = !collapsed">Royalty Charges
        <div class="card-header-actions">
          <CLink class="card-header-action btn-minimize">
            <CIcon :name="`cil-chevron-${collapsed ? 'bottom' : 'top'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="embedded || collapsed" :duration="embedded ? 0 : 400">
        <CCardBody>
          <div class="col-12 text-center" style="color:red;">
            Check the box on the left to apply a royalty charge.
          </div>
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Royalty Charge</th>
                <th>Code</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in group.program_info.royalties">
                <td>
                  <CButton style="width:20px;height:20px;padding:0;" v-if="checkColor(item) === 'yes'" color="success" @click="clickCharge(item)">
                    <CIcon size="sm" name="cil-check" />
                  </CButton>
                  <CButton style="width:20px;height:20px;padding:0;" v-else color="outline-success" @click="clickCharge(item)">
                    <div style="width:15px;height:20px;"></div>
                  </CButton>
                </td>
                <td>{{item.charge_name}}</td>
                <td>{{item.charge_code}}</td>
                <td>{{item.price}}</td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
      </CCollapse>
    </component>
  </div>
</template>
<script>
var methods = {}

methods.checkColor = function (item) {
  var col = ''
  this.group.royalty_charges.forEach(function (charge) {
    if (parseInt(charge.id) === parseInt(item.id)) {
      col = 'yes'
    }
  })
  return col
}

methods.clickCharge = function (item) {
  var found = false
  var i = 0
  var foundIndex = ''
  this.group.royalty_charges.forEach(function (charge) {
    if (charge.id === item.id) {
      found = true
      foundIndex = i
    }
    i++
  })
  if (!found) {
    this.group.royalty_charges.push(item)
  } else {
    this.group.royalty_charges.splice(foundIndex, 1)
  }
  console.log(this.group.royalty_charges)
}

export default {
  // ===Component name
  name: "RoyaltiesTable",
  // ===Props passed to component
  props: {
    group: {
      type: Object,
      required: true
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        fields: ['check', 'charge_name', 'price'],
        collapsed: false
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    console.log('royalties')
    console.log(this.group)
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
